/**
 * Keep last-known club branding across logout and session expiry so /login and
 * landing stay on the same look until the user signs in as another club.
 */
export const LAST_BRAND_CLUB_ID_KEY = "last_brand_club_id";

/** localStorage keys restored after clear() */
export const BRAND_PERSIST_KEYS = [
  "brand_config",
  LAST_BRAND_CLUB_ID_KEY,
  "lng",
  "i18nextLng",
];

export function clearLocalStoragePreservingBrand() {
  const backup = {};
  for (const key of BRAND_PERSIST_KEYS) {
    const v = localStorage.getItem(key);
    if (v != null) backup[key] = v;
  }
  localStorage.clear();
  for (const [k, v] of Object.entries(backup)) {
    localStorage.setItem(k, v);
  }
  try {
    window.dispatchEvent(new Event("smarttt:auth-changed"));
  } catch {
    /* ignore */
  }
}
